<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pVI"></a><a id="pVII"></a>C<span class="fsc">ONTENTS</span></p>
<p class="contents-1"><a href="#/list_of_illustrations.htm"><i>List of Illustrations</i></a></p>
<p class="contents-1"><a href="#/plates.htm"><i>Plates</i></a></p>
<p class="contents-1"><a href="#/ack.htm"><i>Acknowledgements</i></a></p>
<p class="contents-1"><a href="#/family_tree.htm"><i>Family Tree</i></a></p>
<p class="linespace"></p>
<p class="contents-1"><a href="#/intro.htm">Introduction: No Ordinary Enemy</a></p>
<p class="contents"><a href="#/ch1.htm"><span class="numblock">1</span>Hannibal and Carthage</a></p>
<p class="contents"><a href="#/ch2.htm"><span class="numblock">2</span>The Great Man in the Hellenistic World: From Alexander to Hamilcar</a></p>
<p class="contents"><a href="#/ch3.htm"><span class="numblock">3</span>His Father’s Son</a></p>
<p class="contents"><a href="#/ch4.htm"><span class="numblock">4</span>Barcid Iberia from Gades to Saguntum</a></p>
<p class="contents"><a href="#/ch5.htm"><span class="numblock">5</span>Legend: Hannibal into Italy</a></p>
<p class="contents"><a href="#/ch6.htm"><span class="numblock">6</span>Hannibal the Conqueror: From the Trebia to Trasimeno</a></p>
<p class="contents"><a href="#/ch7.htm"><span class="numblock">7</span>The Apogee: Cannae and the War in Italy</a></p>
<p class="contents"><a href="#/ch8.htm"><span class="numblock">8</span>After Cannae</a></p>
<p class="contents"><a href="#/ch9.htm"><span class="numblock">9</span> Hannibal’s Dilemma, 212–209</a></p>
<p class="contents"><a href="#/ch10.htm"><span class="numblock">10</span>Over the Alps, Again</a></p>
<p class="contents"><a id="pVIII"></a><a href="#/ch11.htm"><span class="numblock">11</span>Hannibal Returns</a></p>
<p class="contents"><a href="#/ch12.htm"><span class="numblock">12</span>Hannibal into Exile</a></p>
<p class="linespace"></p>
<p class="contents-1"><a href="#/epilogue.htm">Epilogue: Hannibal’s Afterlife</a></p>
<p class="contents-1"><a href="#/notes.htm"><i>Notes</i></a></p>
<p class="contents-1"><a href="#/biblio.htm"><i>Bibliography</i></a></p>
<p class="contents-1"><a href="#/index.htm"><i>Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6d7b7dd8